import React, { useMemo, useState } from 'react';
import { toast } from 'react-hot-toast';
import { Link } from 'react-router-dom'; // (1) استيراد Link
import { FaPlus } from 'react-icons/fa'; // (2) استيراد أيقونة الإضافة
import styles from '../../../components/layout/Layout.module.css';

import { useServerSideTable } from '../../../hooks/useServerSideTable';
import { getPagedUsers, deleteUser } from '../../../services/userService';
import { User } from '../../../types/user';
import { getUserColumns } from './UserColumns';
import Icon from '../../../components/common/Icon';
import Table from '../../../components/common/Table';
import ConfirmDialog from '../../../components/common/ConfirmDialog';
import pageStyles from '../../Page.module.css';
//import sharedStyles from '../../SharedPageStyles.module.css';
// 1. قم بإنشاء واجهة (interface) لوصف أنواع الخصائص
interface TableHeaderProps {
  searchTerm: string;
  setSearchTerm: React.Dispatch<React.SetStateAction<string>>;
}

// 2. استخدم هذه الواجهة في تعريف المكون
const TableHeader: React.FC<TableHeaderProps> = ({ searchTerm, setSearchTerm }) => {
  return (
    <div style={{ marginBottom: '1rem', maxWidth: '400px' }}>
      <input
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        placeholder="ابحث في الجدول..."
        style={{ width: '100%', padding: '0.8rem', borderRadius: '6px', border: '1px solid #ccc' }}
      />
    </div>
  );
};
const UsersListPage: React.FC = () => {
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [userToDelete, setUserToDelete] = useState<User | null>(null);

  const openDeleteDialog = (user: User) => {
    setUserToDelete(user);
    setIsDeleteDialogOpen(true);
  };

  const closeDeleteDialog = () => {
    setUserToDelete(null);
    setIsDeleteDialogOpen(false);
  };

  const handleDelete = () => {
    if (!userToDelete) return;
    const promise = deleteUser(userToDelete.id);
    toast.promise(promise, {
      loading: 'جاري حذف المستخدم...',
      success: () => {
        closeDeleteDialog();
        refreshData();
        return 'تم حذف المستخدم بنجاح!';
      },
      error: (err) => {
        closeDeleteDialog();
        return err.response?.data?.message || 'فشل في حذف المستخدم.';
      },
    });
  };

  const columns = useMemo(() => getUserColumns(openDeleteDialog), []);

  const { table, isLoading,Pagination, refreshData, searchTerm, setSearchTerm } = useServerSideTable<User>({
    columns,
    fetchData: getPagedUsers,
  });

  return (
    <div className={pageStyles.pageContainer}>
      <div className={styles.pageHeader}>
        <h1>إدارة المستخدمين</h1>
        {/* لا يوجد زر إضافة هنا عادةً */}
        <Link to="/admin/users/add" className={styles.addButton}>
          
          <Icon as={FaPlus} style={styles.icon} />
          <span>إضافة مستخدم</span>
        </Link>
      </div>
      <div className={styles.pageContent}>
        <TableHeader searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
        <Table<User> table={table} isLoading={isLoading} />
        <Pagination />
      </div>
      <ConfirmDialog
        isOpen={isDeleteDialogOpen}
        title="تأكيد الحذف"
        message={`هل أنت متأكد من رغبتك في حذف المستخدم "${userToDelete?.email}"؟ سيتم حذف كل البيانات المرتبطة به.`}
        onConfirm={handleDelete}
        onCancel={closeDeleteDialog}
      />
    </div>
  );
};

export default UsersListPage;
